<template>
  <div>
    <v-data-table
      dense
      item-key="_id"
      class="transparent mt-2"
      :items="dataConfiguration"
      :headers="headers"
      disable-pagination
      hide-default-footer
      :loading="loading"
    >
      <template #loading>
        Loading
      </template>
      <template #item.display="{ item, index }">
        <v-switch
          hide-details
          v-model="item.display"
          @change="ignoreColumn(item, index)"
          label="Hourly/ShiftWise"
          class="my-2"
        ></v-switch>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'DataConfig',
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t('production.column'),
          value: 'text',
          width: '60%',
        },
        {
          text: '',
          value: 'display',
        },
      ],
    };
  },
  computed: {
    ...mapState('webApp', ['appSchema', 'activeAppId']),
    dataConfiguration() {
      let columns = [];
      const schemaDetails = Array.isArray(this.appSchema)
        ? this.appSchema.find((schema) => Array.isArray(schema.downtimeDataConfig)
          && schema.downtimeDataConfig.length)
        : null;
      if (schemaDetails && Array.isArray(schemaDetails.downtimeDataConfig)
        && schemaDetails.downtimeDataConfig.length) {
        columns = [...schemaDetails.downtimeDataConfig];
      }
      const downtimetypeavailable = columns.filter((c) => c.value === 'downtimetypeshift');
      if (downtimetypeavailable.length === 0) {
        columns.push({ text: 'Downtime Type', value: 'downtimetypeshift', display: false });
      }
      return columns;
    },
  },
  methods: {
    ...mapMutations('productionLog', ['setLoading']),
    ...mapActions('webApp', ['getAppSchema', 'updateAppSchema']),
    async ignoreColumn(item, index) {
      const updatedSchema = Array.isArray(this.appSchema)
        ? JSON.parse(JSON.stringify(this.appSchema))
        : [];
      const schemaIndex = updatedSchema.findIndex(
        (schema) => Array.isArray(schema.downtimeDataConfig)
        && schema.downtimeDataConfig.length,
      );
      if (schemaIndex === -1) {
        if (updatedSchema.length > 0) {
          if (!Array.isArray(updatedSchema[0].downtimeDataConfig)) {
            updatedSchema[0].downtimeDataConfig = [];
          }
          updatedSchema[0].downtimeDataConfig[index] = item;
        } else {
          updatedSchema.push({
            downtimeDataConfig: [item],
          });
        }
      } else {
        updatedSchema[schemaIndex].downtimeDataConfig[index] = item;
      }
      this.setLoading(true);
      try {
        await this.updateAppSchema({ appSchema: updatedSchema, saveForAll: false });
        await this.getAppSchema();
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
